 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_EPIGRAPH from '@/components/html/04_Epigraph'
 import HTML05_CONTENTS from '@/components/html/05_CONTENTS'
 import HTML06_PREFACE from '@/components/html/06_Preface'
 import HTML07_LIST_OF_ABBREVIATIONS from '@/components/html/07_List_of_Abbreviations'
 import HTML08_PART_ONE__HUMEAN_REFLECTIONS from '@/components/html/08_Part_One__Humean_Reflections'
 import HTML09_1__IS_HUME_AN_EMPIRICIST from '@/components/html/09_1__Is_Hume_an_Empiricist'
 import HTML10_2__THE_DIALECTIC_OF_TRUE_AND_FAL from '@/components/html/10_2__The_Dialectic_of_True_and_Fal'
 import HTML11_3__THE_ORIGIN_OF_THE_PHILOSOPHIC from '@/components/html/11_3__The_Origin_of_the_Philosophic'
 import HTML12_4__THE_ANCIENT_PHILOSOPHY from '@/components/html/12_4__The_Ancient_Philosophy'
 import HTML13_5__PHILOSOPHY_AND_CHRISTENDOM from '@/components/html/13_5__Philosophy_and_Christendom'
 import HTML14_6__THE_MODERN_PHILOSOPHY from '@/components/html/14_6__The_Modern_Philosophy'
 import HTML15_7__TRUE_PHILOSOPHY_AND_THE_SKEPT from '@/components/html/15_7__True_Philosophy_and_the_Skept'
 import HTML16_8__TRUE_PHILOSOPHY_AND_CIVILIZAT from '@/components/html/16_8__True_Philosophy_and_Civilizat'
 import HTML17_9__FALSE_PHILOSOPHY_AND_BARBARIS from '@/components/html/17_9__False_Philosophy_and_Barbaris'
 import HTML18_10__ENGLISH_BARBARISM___WILKES_A from '@/components/html/18_10__English_Barbarism___Wilkes_a'
 import HTML19_11__ENGLISH_BARBARISM___THE_POOR from '@/components/html/19_11__English_Barbarism___The_Poor'
 import HTML20_PART_TWO__HUMEAN_INTIMATIONS from '@/components/html/20_Part_Two__Humean_Intimations'
 import HTML21_12__HUME_AND_AMERICA from '@/components/html/21_12__Hume_and_America'
 import HTML22_13__THE_RIGHT_OF_RESISTANCE__A_H from '@/components/html/22_13__The_Right_of_Resistance__A_H'
 import HTML23_14__THE_RIGHT_OF_RESISTANCE__SEC from '@/components/html/23_14__The_Right_of_Resistance__Sec'
 import HTML24_15__PRESERVING_ONE_S_HUMANITY_IN from '@/components/html/24_15__Preserving_One_s_Humanity_in'
 import HTML25_NOTES from '@/components/html/25_Notes'
 import HTML26_INDEX from '@/components/html/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_CONTENTS",
 			"name" : "html/05_CONTENTS",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_Preface",
 			"name" : "html/06_Preface",
 			"component" : HTML06_PREFACE
 		},
 		{
 			"path" : "/html/07_List_of_Abbreviations",
 			"name" : "html/07_List_of_Abbreviations",
 			"component" : HTML07_LIST_OF_ABBREVIATIONS
 		},
 		{
 			"path" : "/html/08_Part_One__Humean_Reflections",
 			"name" : "html/08_Part_One__Humean_Reflections",
 			"component" : HTML08_PART_ONE__HUMEAN_REFLECTIONS
 		},
 		{
 			"path" : "/html/09_1__Is_Hume_an_Empiricist",
 			"name" : "html/09_1__Is_Hume_an_Empiricist",
 			"component" : HTML09_1__IS_HUME_AN_EMPIRICIST
 		},
 		{
 			"path" : "/html/10_2__The_Dialectic_of_True_and_Fal",
 			"name" : "html/10_2__The_Dialectic_of_True_and_Fal",
 			"component" : HTML10_2__THE_DIALECTIC_OF_TRUE_AND_FAL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js